export default __webpack_public_path__ + "dacbe1118bb0ab6e16069b7673018287.svg";